import { Space } from 'antd';
import type { FC } from 'react';
import { Icon } from '@/components/icon';
import { Button, Card, PageHeader } from 'components';
import { ExampleFilter } from './Filter';
import { ExampleTable } from './Table';
import { ExampleChart } from './Chart';
import { ExampleStatistics } from './Statistics';

export const DataDetailsPage: FC = () => (
  <Space className="w-100" direction="vertical">
    <PageHeader
      breadcrumbs={[
        { path: '', breadcrumbName: 'Enmon Tools' },
        { path: '', breadcrumbName: 'Examples' },
        { path: '', breadcrumbName: 'Data Detail' },
      ]}
      extra={<Button icon={<Icon iconString="plus" />}>Add New Data</Button>}
      ghost={false}
      title="Data Details"
    />

    <Card>
      <ExampleFilter />
    </Card>
    <Card>
      <ExampleStatistics />
    </Card>
    <Card>
      <Space className="w-100" direction="vertical">
        <ExampleChart />
        <ExampleTable />
      </Space>
    </Card>
  </Space>
);
